import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Link } from "react-router";
import { BUTTON_STYLES, BUTTON_VARIANTS, BUTTON_STYLING_CLASS_MAP, BUTTONTEXT_STYLING_CLASS_MAP } from "./constants";
import { ButtonContent } from "./ButtonContent";
import OnClickButton from "./OnClickButton";
export const CallToAction = ({ buttonStyling = [], title, buttonText, buttonColor = "is2-blue-500", url, priceTag = null, variant = BUTTON_VARIANTS.PRIMARY, image = null, icon = null, onClickFunction = null, parsedClasses = "", isStatic = false, parsedFunctions = {}, downloadableAsset = null, disabled = false, }) => {
    var _a;
    const ctaStyling = useMemo(() => buttonStyling &&
        (buttonStyling === null || buttonStyling === void 0 ? void 0 : buttonStyling.map(type => {
            return BUTTON_STYLING_CLASS_MAP[type] || "";
        }).join(" ")), [buttonStyling]);
    const textStyling = useMemo(() => {
        var _a;
        return (_a = buttonStyling === null || buttonStyling === void 0 ? void 0 : buttonStyling.map(type => BUTTONTEXT_STYLING_CLASS_MAP[type] || "").join(" ").trim()) !== null && _a !== void 0 ? _a : "";
    }, [buttonStyling]);
    const textColor = useMemo(() => {
        if (buttonStyling === null || buttonStyling === void 0 ? void 0 : buttonStyling.includes(BUTTON_STYLES.ORANGE)) {
            return "text-white";
        }
        switch (variant) {
            case BUTTON_VARIANTS.PRIMARY:
                return "text-white";
            case BUTTON_VARIANTS.SECONDARY:
                return "text-is2-gray-700";
            case BUTTON_VARIANTS.BASIC:
                return "text-is2-gray-700";
            case BUTTON_VARIANTS.JUMBO:
                return "text-is2-gray-800";
            case BUTTON_VARIANTS.AS_LINK:
                return "text-inherit";
            default:
                return "text-white";
        }
    }, [variant, buttonStyling]);
    const buttonContentProps = {
        variant,
        image,
        ctaStyling,
        icon,
        priceTag,
        textColor,
        textStyling,
        buttonText: buttonText || title,
        title,
        parsedClasses,
        buttonStyling,
        buttonColor,
        disabled,
    };
    if (onClickFunction !== null && !isStatic) {
        return (_jsx(OnClickButton, { onClickFunctionId: onClickFunction, buttonContentProps: buttonContentProps, parsedFunctions: parsedFunctions, downloadableAssetId: (_a = downloadableAsset === null || downloadableAsset === void 0 ? void 0 : downloadableAsset.sys) === null || _a === void 0 ? void 0 : _a.id }));
    }
    if (url) {
        return (_jsx(Link, { to: url, children: _jsx(ButtonContent, Object.assign({}, buttonContentProps)) }));
    }
    return _jsx(ButtonContent, Object.assign({}, buttonContentProps));
};
